import { Box, Typography} from "@mui/material";
import PatrolStatus from "../components/widgets/PatrolStatus";
import TaskList from "../components/widgets/TaskList";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { PatrolUITheme } from "../utils/theme/PatrolUITheme";
import PatrolManageStatus from "../components/widgets/PatrolManageStatus";

const PatrolUIPage = () => {

  const { patrolId } = useParams();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  let userCallSign = user?.resource_id;
  if(patrolId != null && patrolId != undefined) {
    userCallSign = useSelector(state => state.patrols.allPatrols.find(p => p.id == patrolId))?.callsign;
  }

  const patrol = useSelector(state => state.patrols.allPatrols.find(p => p.callsign == userCallSign));
  useEffect(() => {
    dispatch({
      type: 'auth/setImpersonatedPatrol',
      payload: patrolId
    });
  }, []);

  useEffect(() => {
    let wasHidden = false;

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        wasHidden = true;
      } else if (document.visibilityState === "visible" && wasHidden) {
        // Page was hidden, now it's back — refresh it
        location.reload(); // or window.location.reload();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <PatrolUITheme>
      <Box sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        width: {
          lg: '450px'
        },
        margin: {
          lg: '0 auto'
        }
        
      }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            width: '100%',
            p: '0px 0px',
          }}
        >
          <Box
            sx={t => ({
              position: 'sticky',
              top: { xs: 64, md: 64 },
              zIndex: t.zIndex.appBar - 1,
              bgcolor: 'background.white',
              pb: 0,
            })}
          >
            <PatrolStatus user={user} patrol={patrol} impersonatedUser={patrolId} />
          </Box>
          <TaskList
            user={user}
            patrol={patrol}
            impersonatedUser={patrolId}
          />
          <PatrolManageStatus patrol={patrol} impersonatedUser={patrolId} />
        </Box>

        {/* FOOTER */}
        <Box component="footer" sx={{ py: 2, px: 3, bgcolor: 'background.white' }}>
          <Typography variant="body2" color="text.secondary">
            © Automobile Association Developments Ltd.
          </Typography>
        </Box>
      </Box>

    </PatrolUITheme>
  );
};

export default PatrolUIPage;

